<template>
  <!-- 实时供水量 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">原水水位、流量栏目</span>
    </div>
    <div v-show="!isDiagram" class="mainContain">
      <div class="mainItem">
        <div class="title">沉沙池水位：3.23cm</div>
        <div class="clickTitle" @click="toDiagram('沉沙池水位')">跳转曲线图</div>
      </div>
      <div class="mainItem">
        <div class="title">瞬时流量：806m³</div>
        <div class="clickTitle" @click="toDiagram('瞬时流量')">跳转曲线图</div>
      </div>
      <div class="mainItem">
        <div class="title">累积流量：31305527m³</div>
      </div>
    </div>
    <!-- <div v-if="isDiagram" class="mainBackContain">
      <div class="backWarp">
        <div class="back" @click="toBack">返回</div>
        <span class="backTitle">{{ diagramTitle }}曲线图</span>
      </div>
      <div :id="id" class="main"></div>
    </div> -->
    <div v-if="isDiagrams" class="mainBackContain">
      <div class="backWarp">
        <div class="back" @click="toBack">返回</div>
        <span class="backTitle">{{ diagramTitle }}曲线图</span>
      </div>
      <div :id="id" class="main"></div>
    </div>
  </div>
</template>

<script>
import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../utils/util'
export default {
  mixins: [chartResize],
  name: 'WaterSupply',
  components: {},
  data () {
    return {
      timer: {},
      id: getUUID(),
      myChart: null,
      isDiagram: false,
      // isDiagrams: false,
      diagramTitle: '',
      color: [
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.5,
              color: 'rgba(115,215,255,0.70)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(4,224,239,0.00)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        },
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.5,
              color: 'rgba(0,11,199,0.70)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(44,117,252,0)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      ],
      lineColor: ['#73A7FF', '#000BC7']
    }
  },

  created () { },
  beforeDestroy () {
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.queryData()
      this.getEchartData()
    })
  },
  beforeDestroy () {
    console.log(this.timer)
    clearInterval(this.timer)
  },
  methods: {
    // Instantaneous(title) {
    //   this.isDiagrams = true
    //   this.diagramTitle = title
    //   this.queryData()
    // },
    toDiagram (title) {
      this.isDiagram = true
      this.diagramTitle = title
      this.queryData()
    },
    toBack () {
      // this.isDiagrams = false
      this.isDiagram = false
    },
    getEchartData () {
      this.timer = setInterval(() => {
        this.queryData()
        // 你获取echarts数据的方法
      }, 1000 * 30)
    },
    queryData () {
      const params = {
        queryBeginTime: '2021-09-02 00:00:00',
        queryEndTime: '2021-09-03 00:00:00'
      }
      this.$http.get('/pipe-network/report/chart/report-total', { params }).then((res) => {
        // res.data=res.data.reverse()
        var series = []
        var xData = []

        for (let i = 0; i < res.data.length; i++) {
          const isTime = res.data[1].timeSumDates.length
          const dataS = res.data[i]
          const seriesData = []
          for (let j = 0; j < dataS.timeSumDates.length; j++) {
            seriesData.push(dataS.timeSumDates[j].cumulate)
            if (isTime != 0 && i == 1) {
              // console.log(dataS.timeSumDates[j].time.substring(10, 16))
              xData.push(dataS.timeSumDates[j].time.substring(10, 16))
            }
            if (isTime == 0 && i == 0) {
              xData.push(dataS.timeSumDates[j].time.substring(10, 16))
            }
          }
          series.push({
            showAllSymbol: true,
            zlevel: -i,
            z: -i,
            name: dataS.dateTime,
            data: seriesData,
            symbol: 'none',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: this.color[i]
            },
            lineStyle: {
              color: this.lineColor[i]
            }
          })
        }
        const data = {
          series: series,
          xData: xData
        }
        this.set(data)
      })
    },
    set (data) {
      this.myChart = echarts2.init(document.getElementById(this.id))

      var option
      option = {
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0.5,
                color: 'rgba(115,215,255,0.70)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(4,224,239,0.00)' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0.5,
                color: 'rgba(0,11,199,0.70)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(44,117,252,0)' // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        ],
        title: {
          subtext: 'cm',
          subtextStyle: {
            fontSize: '14px',
            color: '#98BDFF'
          },
          top: 0,
          left: 40
        },
        legend: {
          left: 'right',
          //   right:200,
          top: 1,
          left: 400,
          textStyle: {
            color: '#98BDFF'
          }
        },
        grid: [{ right: '0', top: '24px', left: '0', bottom: '5%', width: '95%', height: '90%', containLabel: true }],
        tooltip: {
          snap: true,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderRadius: 4,
          borderWidth: 0,
          textStyle: {
            color: '#FFFFFF',
            fontSize: 14
          }
        },
        // dataZoom: [
        //   // {
        //   //   show: false,
        //   //   realtime: true,
        //   //   type: 'slider',
        //   //   start: 0,
        //   //   end: 30,
        //   //   xAxisIndex: [0, 1],
        //   //   fillerColor: 'rgba(255, 255, 255, 0.1)', // 选中范围的填充颜色。
        //   //   //  backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色
        //   //   height: 18,
        //   //   handleSize: '80%',
        //   //   handleStyle: {
        //   //     borderWidth: 1
        //   //   },
        //   //   borderColor: 'rgba(255, 255, 255, 0.2)',
        //   //   showDataShadow: false, //是否显示数据阴影 默认auto
        //   //   showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
        //   //   filterMode: 'none',
        //   //   bottom: '4%'
        //   // },
        //   {
        //     type: 'inside'
        //   }
        // ],
        xAxis: [
          {
            type: 'category',
            // boundaryGap: true,
            // boundaryGap: false, // 距离坐标原点是否有间隙
            data: data.xData,
            // interval: 10,
            axisLabel: {
              // interval: 17, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
              textStyle: {
                color: '#98BDFF'
              }
            },
            splitLine: {
              // 改变竖向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#98BDFF'
              }
            },
            splitLine: {
              // 改变横向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: data.series
      }
      console.log(option)
      this.myChart.clear()
      this.myChart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 224px;
  width: 600px;
  background: url(~@/assets/myImg/h_10_yssw_box.png) no-repeat;
  background-size: contain;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 18px;
      color: #00ebee;
      text-align: center;
      font-weight: 600;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .mainContain {
    padding: 0 20px;
    position: absolute;
    bottom: 24px;

    .mainItem {
      margin-top: 12px;
      width: 560px;
      height: 48px;
      background: url(~@/assets/myImg/h_9_yssw_zb_box.png) no-repeat;
      background-size: contain;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 24px;

      .title {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 16px;
        color: #00ebee;
        font-weight: 600;
      }

      .clickTitle {
        width: 108px;
        height: 100%;
        border-left: 1px solid #094279;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        color: #10c0ff;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }

    :first-child {
      margin: 0;
    }
  }

  .mainBackContain {
    height: 224px;
    width: 600px;
    padding: 2px 20px;
    position: absolute;
    bottom: 0px;

    .main {
      position: absolute;
      top: 16px;
      // float: left;
      width: 572px;
      height: 178px;
      width: 100%;
    }

    .backWarp {
      .back {
        cursor: pointer;
        background: rgba(16, 192, 255, 0.3);
        border-radius: 5px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #00f6ff;
        font-weight: 400;
        text-align: center;
        width: 38px;
        height: 18px;
      }
    }
  }
}
</style>
